import React, { useCallback } from 'react';

import { Organization } from 'src/common/interfaces/organization.interface';
import { useCurrentOrganization } from 'src/store/organization';
import { Button } from 'src/common/button';
import { BrandFormik } from 'src/common/forms/brand-formik';

interface DashboardSettingsBrandProps {
  showGuidance?: boolean;
  showFindBranding?: boolean;
  shouldFetchBranding?: boolean;
  currentOrganization: Organization;
  onSuccess?: () => void;
}

export const DashboardSettingsBrand = ({
  showGuidance = true,
  showFindBranding = true,
  shouldFetchBranding = false,
  onSuccess,
}: DashboardSettingsBrandProps) => {
  const { currentOrganization, setCurrentOrganization } = useCurrentOrganization();

  const actionButtonRenderer = useCallback((submitting: boolean, dirty: boolean) => {
    return <Button type='submit' variant='primary' size='regular' disabled={!dirty || submitting} label='Save' />;
  }, []);

  return (
    <div className='flex flex-row space-x-xl relative mt-md'>
      <BrandFormik
        showGuidance={showGuidance}
        showFindBranding={showFindBranding}
        shouldFetchBranding={shouldFetchBranding}
        onSuccess={onSuccess}
        organization={currentOrganization}
        setOrganization={setCurrentOrganization}
        actionButtonRenderer={actionButtonRenderer}
      />
    </div>
  );
};
